import styled from "styled-components";
import { useTranslation } from "react-i18next";

export default function MayoFooter() {
  const { t } = useTranslation();

  return (
    <Footer>
      <FooterText>
        <span>{t("Footer").split(",")[0] + ","}</span>
        <span>{t("Footer").split(",").slice(1).join(",").trim()}</span>
      </FooterText>
    </Footer>
  );
}

const Footer = styled.div`
  justify-content: center;
  text-align: center;
  margin-bottom: 70px;
`

const FooterText = styled.p`
  margin-inline: 46px;
  font-size: 24px;
  font-weight: 500;
  padding-inline: 20px;
  span {
    display: block;
  }
`
